/**
 * Auth Module
 */
/* eslint-disable */
import Vue from 'vue'
// import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'
import loginService from '@/services/loginService'
import VueRouter from 'vue-router'
import router from '@/router/router'

var isDebug = false
const state = {
    vssUserDto: null,
    userAgencyDto: null
}

// getters
const getters = {
    vssUserDto: state => {
        return state.vssUserDto
    },
    userAgencyDto: state => {
        return state.userAgencyDto
    }
}

// actions
const actions = {
    authenticated ({ dispatch, commit }) {
        let result = loginService.updateUserStore(commit).then(() =>
        {
            if (loginService.requiresSetup()) {
                router.push('/user-setup')
            }
        })
        return result
    },
    logout ({ commit }) {
        commit('resetState', 'auth')
    }
}

// mutations
const mutations = {
    setVssUserDto(state, value) {
        state.vssUserDto = value
    },
    resetState(state) {
        Object.assign(state, {
            vssUserDto: null
        })
    },
    setUserAgencyDto(state, value) {
        state.userAgencyDto = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
